import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { SkeletonColored } from '~/screens/MyAgency/components/StackView/CreatorSkeleton';
import { convertPxToRems } from '~/utils-ts';

export const ProfileCardSkeleton = () => {
  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      justifyContent="center"
      alignItems="center"
      flex="1 0 0"
      alignSelf="stretch"
    >
      <Box
        height="calc(100% - 128px)"
        width="100%"
        maxWidth={{
          md: convertPxToRems(700),
        }}
        maxHeight={{
          md: convertPxToRems(700),
        }}
        aspectRatio="1/1"
        borderRadius={{ base: 'none', md: '3xl' }}
        overflow="hidden"
      >
        <SkeletonColored
          height="700px"
          width="700px"
          borderRadius={{ base: 'none', md: '3xl' }}
          startColor="var(--media-kit-background-skeleton)"
        />
      </Box>
      <Flex
        backgroundColor="var(--media-kit-background-primary)"
        transform={{
          base: 'translateY(-48px)',
          md: 'translateX(-64px)',
        }}
        borderRadius="3xl"
        boxShadow={{
          base: 'none',
          md: '0px 4px 16px 0px rgba(28, 33, 40, 0.20)',
        }}
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        width="100%"
        zIndex={1}
      >
        <Flex
          flexDirection="column"
          gap={6}
          padding={8}
          alignItems="center"
          width="100%"
        >
          <SkeletonColored
            className="h-8 w-[220px]"
            startColor="var(--media-kit-background-skeleton)"
          />
          <Flex gap={6}>
            {Array(3)
              .fill(0)
              .map((_, index) => (
                <Flex
                  key={index}
                  flexDirection="column"
                  gap={2}
                  alignItems="center"
                >
                  <SkeletonColored
                    className="size-8"
                    startColor="var(--media-kit-background-skeleton)"
                  />
                  <SkeletonColored
                    className="h-2 w-10"
                    startColor="var(--media-kit-background-skeleton)"
                  />
                </Flex>
              ))}
          </Flex>
          <Flex gap={2}>
            {Array(2)
              .fill(0)
              .map((_, index) => (
                <SkeletonColored
                  key={index}
                  className="h-8 w-14"
                  startColor="var(--media-kit-background-skeleton)"
                />
              ))}
          </Flex>
          <div className="h-[1px] w-full bg-[var(--media-kit-background-alpha)]" />

          <Flex flexDirection="column" width="100%" gap={6}>
            <Flex justifyContent="space-between">
              <SkeletonColored
                className="h-3 w-[207px]"
                startColor="var(--media-kit-background-skeleton)"
              />
              <SkeletonColored
                className="h-3 w-18"
                startColor="var(--media-kit-background-skeleton)"
              />
            </Flex>
            <Flex flexDirection="column" gap={3}>
              <SkeletonColored
                className="h-3 w-18"
                startColor="var(--media-kit-background-skeleton)"
              />
              {Array(3)
                .fill(0)
                .map((_, index) => (
                  <SkeletonColored
                    key={index}
                    className="h-3 w-full"
                    startColor="var(--media-kit-background-skeleton)"
                  />
                ))}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
